export default __webpack_public_path__ + "static/media/image.493f9543.png";